export const isExistPathChild = (select: string, item: string): boolean => {
  const availablePath = ['create', 'view', 'edit'];
  const paths = select.replace(item, '').split('/').slice(1);
  const isValidParent =
    paths.length > 0 ? availablePath.indexOf(paths?.[0]) !== -1 : false;

  return select === item || (select.startsWith(item) && isValidParent);
};
